import { Helmet } from "react-helmet-async";

const SITE_NAME = "CAMARAGO";

const DEFAULT_DESCRIPTION =
  "CAMARAGO(カマラゴ)は、あなたに最適な防犯カメラ・監視カメラを直感的な選択形式で選べるサービスです。設置までもワンストップで提供します。";

const DEFAULT_IMAGE = "https://camarago.com/images/camarago_ogp.jpg";

const DEFAULT_URL = "https://camarago.com";

export default function Seo({
  pageTitle,
  description = DEFAULT_DESCRIPTION,
  url = DEFAULT_URL,
  image = DEFAULT_IMAGE,
}) {
  const title = pageTitle ? `${pageTitle} | ${SITE_NAME}` : SITE_NAME;
  return (
    <Helmet>
      <html lang="ja" />

      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
